import React from 'react'
// import CrossGrayIcon from '../../common/images-new/cross-gray-icon.svg'
import ButtonBlue from '../Button/ButtonBlue'
import { useHistory } from 'react-router-dom'
import { staticFiles } from '../Helpers/Static'
import InputLabel from '@mui/material/InputLabel';
// import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { BgBlue, Card, ButtonCommonTopNew, LiDiv, TextDarkBlue, TextGray, MenuItemCard, MenuItemDiv, headerDiv } from "../../pages/Theme";
const CROSS_GRAY_ICON = staticFiles.cross;

const ModalAddPost = ({ handleClose,
    show,
    addPostLoader,
    onClick,
    dropdownOption,
    value,
    onChange,
    failed,
    buttonDisabled,
    tabId,
    showcasesCount
}) => {

    const history = useHistory()
    const showHideModal = show
        ? 'block fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 modelIndex'
        : 'hidden'
    return (
        <div className={showHideModal} >
            <div className="fixed inset-0 modelIndex flex items-center justify-center bg-black bg-opacity-50 px-4 py-6">
                <div className={`relative cardBackgroundColor rounded-xl shadow-md p-4 max-w-full max-h-screen overflow-auto top-2 bottom-2 right-2 left-2 modal-popup-width`}>
                    <div className="flex gap-2 items-center justify-between">
                        <p className="font-semibold blackColor">Add Post</p>
                        <button
                            onClick={handleClose}
                            className="text-gray-600 hover:text-black text-xl font-bold"
                        >&times;
                        </button>
                    </div>
                    <div className="mt-5 text-center justify-center">
                        <ButtonCommonTopNew className="px-5 border p-2 text-sm cursor-pointer rounded-full-tab hover:opacity-80" onClick={() => history.push("/journal/new", { src: "/", tabId, showcasesCount })}>
                            Create New Post
                        </ButtonCommonTopNew>
                    </div>
                    <p className="flex justify-center py-2">or</p>
                    <div className="flex flex-col space-y-5">
                        <div>
                            <FormControl className="w-full rounded-full-tab">
                                <Select
                                    value={value || ""}
                                    onChange={onChange}
                                    displayEmpty
                                    size="small"
                                    fullWidth
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    MenuProps={{
                                        disableScrollLock: true,
                                    }}
                                >
                                    <MenuItem className="DropDownFont" value="">
                                        <MenuItemDiv className="blackColor">
                                            Select post
                                        </MenuItemDiv>
                                    </MenuItem>
                                    {dropdownOption &&
                                        dropdownOption.map((option, index) =>
                                            <MenuItem className="DropDownFont" value={option.reflection_id}>
                                                <MenuItemDiv className="blackColor">
                                                    {option.reflection_title}
                                                </MenuItemDiv>
                                            </MenuItem>
                                        )
                                    }
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    {failed === true &&
                        <span className="cover-file-show-error text-red-500 text-xs">Add post to showcase failed</span>
                    }
                    <div className="pt-5 flex justify-end">
                        <ButtonCommonTopNew className={`px-5 border p-2 text-sm rounded-lg ${addPostLoader ? "pointer-events-none" : "cursor-pointer"} `} onClick={onClick} disabled={buttonDisabled}>
                            Add
                        </ButtonCommonTopNew>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalAddPost